/**
 * Utility function to get either the _id or _key property from an object.
 * Returns _id if present, otherwise returns _key.
 *
 * @param obj - Object that may have _id and/or _key properties
 * @returns The _id or _key value
 */
export function idOrKey<T extends { _id?: string; _key?: string }>(obj: T): string {
  // Both properties are optional, so the result is undefined for an object carrying neither.
  // Callers consume it as a required string — as array elements, object keys, and instruction
  // ids — and widening the return type to `string | undefined` fails to compile in eight other
  // files, so making this honest is its own change rather than part of a lint cleanup.
  // oxlint-disable-next-line typescript/no-non-null-assertion
  return (obj._id || obj._key)!;
}
